import { render } from "./AppTabPanels.vue?vue&type=template&id=27b9c85c&ts=true"
import script from "./AppTabPanels.vue?vue&type=script&lang=ts"
export * from "./AppTabPanels.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__